export default class FlutterServiceError extends Error {
    constructor(message) {
      super("Flutter Service Error: " + message); // (1)
      this.name = "FlutterServiceError"; // (2)
    }
  }
